export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  FOLDERS: '/folders',
  FOLDER: '/folders/*',
  PROJECTS: '/projects',
  PROJECT: '/projects/:projectId',
  PROJECT_INSPECTIONS: '/projects/:projectId/inspections',
  PROJECT_CHECKLISTS: '/projects/:projectId/checklists',
  PROJECT_INSPECTION_POI_STEP: '/projects/:projectId/inspections/:inspectionId/poi/:poiId/steps/:stepIndex',
  VIEWER_PROJECT: '/viewer/projects/:projectId',
  VIEWER_PROJECT_INSPECTION: '/viewer/projects/:projectId/inspections/:inspectionId',
  VIEWER_PROJECT_INSPECTION_POI_STEP: '/viewer/projects/:projectId/inspections/:inspectionId/poi/:poiId/steps/:stepIndex',
  USERS: '/users',
  SETTINGS: '/settings',
  SERVER_CONFIG: '/server-config',
  NOT_FOUND: '*'
} as const;

export type RoutePaths = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS];
